
















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { checkMobile } from '../../utils/utils'
import ChartProgress from './ChartProgress.vue'

@Component({
  components: {
    ChartProgress
  }
})
export default class DashboardProgress extends Vue {
  @Prop()
  progressRate: number

  mobile = checkMobile()
}
